import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SectorFocus } from "@/components/SectorFocus";
import { Reveal, Eyebrow, ArrowLink } from "@/components/Reveal";

export default function Sectors() {
  return (
    <main className="bg-[#F6F4F0] text-[#1F1E1B] antialiased">
      <Navbar />

      <section data-testid="sectors-hero" className="pt-40 lg:pt-52 pb-16 lg:pb-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <Eyebrow>Sectors</Eyebrow>
            <h1 className="mt-8 font-serif text-4xl sm:text-5xl lg:text-7xl font-light tracking-tight text-[#1F1E1B] leading-[1.05] max-w-5xl">
              Real Assets & <span className="italic">Special Situations.</span>
            </h1>
            <p className="mt-8 max-w-2xl text-base sm:text-lg font-light leading-relaxed text-[#6E6A61]">
              Hotels, major property portfolios, commercial real estate, aviation businesses,
              infrastructure and complex ownership situations — advised with the same discretion and
              rigour as the firm's corporate and private capital work.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-28 lg:pb-40">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <SectorFocus />
          <Reveal delay={0.2}>
            <div className="mt-16">
              <ArrowLink to="/contact" testid="sectors-enquiry-link">
                Discuss a Mandate
              </ArrowLink>
            </div>
          </Reveal>
        </div>
      </section>

      <Footer />
    </main>
  );
}
